import StyledResponsiveImg from '../../components/ResponsiveImg/StyledResponsiveImg';

interface ProductImageProps {
  display?: string;
  minHeight?: string;
  minWidth?: string;
  padTop?: string;
  width?: string;
}

const ProductImg = StyledResponsiveImg<ProductImageProps>`
  padding-top: ${props => (props.padTop ? props.padTop : '5%')};
  width: ${props => (props.width ? props.width : '100%')};
  height: auto;
  ${props => props.minWidth && `min-width: ${props.minWidth};`}
  ${props => props.minHeight && `min-height: ${props.minHeight};`}
  ${({ display }) => (display ? `display: ${display}` : '')};
`;

export default ProductImg;
